/**
 * Eligible zipcodes for Novavax COVID-19 Vaccine Study (65+)
 * Generated from CSV - DO NOT EDIT MANUALLY
 * Total zipcodes: 237
 */
export const novavax65EligibleZipCodes: readonly string[] = [
  "41011", "41012", "41014", "41016", "41017", "41019", "41021", "41025", "41048", "41071",
  "41072", "41073", "41074", "41075", "41076", "41085", "41099", "45001", "45002", "45004",
  "45005", "45011", "45012", "45013", "45014", "45015", "45018", "45030", "45033", "45034",
  "45036", "45039", "45040", "45041", "45042", "45044", "45050", "45051", "45052", "45053",
  "45055", "45056", "45061", "45062", "45063", "45064", "45065", "45067", "45069", "45071",
  "45111", "45122", "45140", "45147", "45150", "45152", "45174", "45201", "45202", "45203",
  "45204", "45205", "45206", "45207", "45208", "45209", "45211", "45212", "45213", "45214",
  "45215", "45216", "45217", "45218", "45219", "45220", "45221", "45222", "45223", "45224",
  "45225", "45226", "45227", "45229", "45230", "45231", "45232", "45233", "45234", "45235",
  "45236", "45237", "45238", "45239", "45240", "45241", "45242", "45243", "45244", "45245",
  "45246", "45247", "45248", "45249", "45250", "45251", "45252", "45253", "45254", "45255",
  "45258", "45262", "45263", "45264", "45267", "45268", "45269", "45270", "45271", "45273",
  "45274", "45275", "45277", "45280", "45296", "45298", "45299", "45999", "51501", "51502",
  "51503", "51510", "51526", "51542", "68002", "68005", "68007", "68008", "68010", "68016",
  "68022", "68023", "68028", "68034", "68046", "68056", "68059", "68064", "68068", "68069",
  "68073", "68101", "68102", "68103", "68104", "68105", "68106", "68107", "68108", "68109",
  "68110", "68111", "68112", "68113", "68114", "68116", "68117", "68118", "68119", "68122",
  "68123", "68124", "68127", "68128", "68130", "68131", "68132", "68133", "68134", "68135",
  "68136", "68137", "68138", "68139", "68142", "68144", "68145", "68147", "68152", "68154",
  "68157", "68164", "68172", "68175", "68176", "68178", "68179", "68180", "68182", "68183",
  "68197", "68198", "70501", "70502", "70503", "70504", "70505", "70506", "70507", "70508",
  "70509", "70511", "70512", "70513", "70517", "70518", "70519", "70520", "70521", "70528",
  "70529", "70533", "70541", "70555", "70558", "70560", "70562", "70563", "70575", "70578",
  "70582", "70583", "70584", "70592", "70593", "70596", "70598",
] as const;
